module.exports = __webpack_public_path__ + "img/knsu_detail.b78cc340.jpg";